// extracted by mini-css-extract-plugin
export var bold = "fp-il";
export var caption = "fp-gl";
export var ctaLarge = "fp-ll";
export var eyebrow = "fp-fl";
export var h1 = "fp-5k";
export var h1Large = "fp-6k";
export var h2 = "fp-7k";
export var h3 = "fp-9k";
export var h4 = "fp-al";
export var h5 = "fp-bl";
export var h6 = "fp-cl";
export var italic = "fp-jl";
export var markdownImgContainer = "fp-ol";
export var markdownText = "fp-ml";
export var markdownTextArticle = "fp-pl";
export var markdownTextLegal = "fp-8k";
export var markdownText__highlight = "fp-nl";
export var mt0 = "fp-_k";
export var mt1 = "fp--k";
export var mt2 = "fp-0k";
export var mt3 = "fp-1k";
export var mt4 = "fp-2k";
export var mt5 = "fp-3k";
export var mt6 = "fp-4k";
export var p = "fp-dl";
export var pSmall = "fp-el";
export var sideNavLabel = "fp-kl";
export var stat = "fp-hl";